var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[(_vm.value === false)?_c('b-spinner',{attrs:{"label":"Spinning"}}):(_vm.value === true)?_c('b-icon-check'):_vm._e(),_vm._v(" Actualización de exclusiones ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }